(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLOSE_MS = 360;

  function closestGroup(el) {
    return el.closest('[data-tt-faqs-group]');
  }

  function openItem(details) {
    if (details._ttCloseTimer) {
      window.clearTimeout(details._ttCloseTimer);
      details._ttCloseTimer = null;
    }
    details.setAttribute('open', '');
    // Allow the closed grid state to paint before expanding.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        details.classList.add('is-open');
      });
    });
  }

  function closeItem(details) {
    if (!details.hasAttribute('open') && !details.classList.contains('is-open')) return;

    details.classList.remove('is-open');

    if (reduceMotion) {
      details.removeAttribute('open');
      return;
    }

    if (details._ttCloseTimer) {
      window.clearTimeout(details._ttCloseTimer);
    }
    details._ttCloseTimer = window.setTimeout(function () {
      details.removeAttribute('open');
      details._ttCloseTimer = null;
    }, CLOSE_MS);
  }

  function closeOthersInGroup(details) {
    var group = closestGroup(details);
    if (!group) return;
    group.querySelectorAll('[data-tt-faqs-item]').forEach(function (other) {
      if (other === details) return;
      closeItem(other);
    });
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-tt-faqs-item]').forEach(function (details) {
      var summary = details.querySelector('.tt-faqs__question');
      if (!summary) return;

      if (details.open) {
        details.classList.add('is-open');
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = details.classList.contains('is-open');

        if (isOpen) {
          closeItem(details);
        } else {
          closeOthersInGroup(details);
          openItem(details);
        }
      });
    });
  }

  function initNav(root) {
    var links = root.querySelectorAll('[data-tt-faqs-nav-link]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        var target = href ? document.querySelector(href) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', href);
        }
        links.forEach(function (l) {
          l.classList.toggle('is-active', l === link);
        });
      });
    });

    var groups = root.querySelectorAll('[data-tt-faqs-group][id]');
    if (!groups.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          });

        if (!visible.length) return;
        var id = visible[0].target.id;
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
        });
      },
      {
        rootMargin: '-20% 0px -55% 0px',
        threshold: [0.15, 0.35, 0.55],
      }
    );

    groups.forEach(function (group) {
      observer.observe(group);
    });
  }

  function initReveals(root) {
    var nodes = root.querySelectorAll('[data-tt-faqs-reveal]');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var delayBuckets = new WeakMap();

    nodes.forEach(function (node) {
      var parent = node.parentElement;
      var index = delayBuckets.get(parent) || 0;
      delayBuckets.set(parent, index + 1);
      node.style.setProperty('--tt-faqs-delay', Math.min(index, 6) * 60 + 'ms');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initFaqs(root) {
    if (root.dataset.ttFaqsReady === 'true') return;
    root.dataset.ttFaqsReady = 'true';
    initAccordion(root);
    initNav(root);
    initReveals(root);
  }

  document.querySelectorAll('[data-tt-faqs]').forEach(initFaqs);
})();
